import classifiesAsPitch from "../../classificators/pitchCall/classifiesAsPitch.js";
import sessionCouldHaveNewScoringData from "../../classificators/sessionContents/sessionCouldHaveNewScoringData.js";
import gameOnly from "../../classificators/sessionType/gameOnly.js";
import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import DataSection from "../../enums/DataSection.js";
import PitchData from "../../enums/PitchData.js";
import ResultData from "../../enums/ResultData.js";
import ResultType from "../../enums/ResultType.js";
import ScoringData from "../../enums/ScoringData.js";
import EnumValueProvider from "../../providers/EnumValueProvider.js";
import ContextualFilterBase from "./ContextualFilterBase.js";

class ClassifiedPitchesFilter extends ContextualFilterBase {
    constructor(customResultsProcessor, pitchClassifier) {
        if (typeof(customResultsProcessor) !== 'undefined' && !(customResultsProcessor instanceof IterableDataProcessor)) {
            throw new TypeError('customResultsProcessor must be an instance inheriting from IterableDataProcessor class');
        }
        if (typeof(pitchClassifier) !== 'undefined' && typeof(pitchClassifier) !== 'function') {
            throw new TypeError('pitchClassifier must be undefined or predicate taking single argument - pitch call value');
        }

        super();

        this.resultsProcessor = customResultsProcessor || new IterableDataProcessor(
            new EnumValueProvider()
        );
        this.pitchClassifier = pitchClassifier || classifiesAsPitch;
    }

    filter(results, session, league) {
        // for game with scoring we can determine in precisely
        if (
            gameOnly(session.sessionType)
            && sessionCouldHaveNewScoringData(
                session.parameters.SessionContents, session.parameters.SessionSchemaRef
            )
        ) {
            return this.resultsProcessor.filterData(
                results, [{
                    parameter: ResultData.getDataPath(
                        ScoringData.PitchCall.key, DataSection.Scoring.key
                    ),
                    operator: 'function',
                    value: this.pitchClassifier
                }]
            );
        }

        // if no scoring data or we have just radar data... return all pitches
        return this.resultsProcessor.filterData(
            results, [{
                parameter: ResultData.mapPath(ResultData.Type.key),
                operator: 'CONTAINS',
                value: ResultType.Pitch.key
            }]
        );
    }
}

export default ClassifiedPitchesFilter;